<template>
<app-content-admin>
  <template slot="header">{{ $t('banners') }}</template>

  <v-layout row wrap>
    <v-flex xs12 class="text-right">      
      <v-btn color="primary" @click="$router.push({name: 'banner_new'})" class="form-btn">New Banner</v-btn>
    </v-flex>

    <v-flex xs12>
        <v-row>
            <v-col cols="3">
                <v-text-field
                    label="Status"
                    outlined
                    dense
                ></v-text-field>
            </v-col>

            <v-col
                cols="3"
            >
                <v-btn color="primary">Search</v-btn>
            </v-col>
        </v-row>
    </v-flex>

    <v-flex xs12>
      <v-card class="pa-3">
        <table class="table table-fluid no-wrap">
          <thead>
              <th scope="col">Title</th>
              <th scope="col">Description</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td>{{ row.title }}</td>
              <td>{{ row.description }}</td>
              <td>
                  <active-label :status="row.is_active"></active-label>
              </td>
              <td>{{ row.created_at }}</td>
              <td>
                <v-btn :to="{name: 'banner_edit', params: {id: row.id}}" icon>
                  <v-icon>mdi-file-edit-outline</v-icon>
                </v-btn>
                <!-- <v-btn @click="delete(row.id)" color="error" icon>
                  <v-icon>mdi-delete-forever-outline</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </tbody>
        </table>
        <v-layout justify-center>
          <v-flex xs8>
            <div class="text-xs-center"  v-if="pages > 0">
              <v-pagination v-model="page" :length="pages" @input="onListChange"></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</app-content-admin>
</template>

<script>
import ActiveLabel from '@/components/status/ActiveLabel'

export default{

    data: () => ({
        rows:[],
        pages:0,
        page:1,
        form: {
            offset: 1,
            page: 10,
        },

        status: [
            {name: "Active", value: 'active'},
            {name: "Inactive", value: 'inactive'},
        ],

        bannerDialog: false,

    }),

    components: {
      ActiveLabel
    },

    mounted() {
        this.search();
    },

    methods: {
        search(offset = 10, page = 1) {
            this.form.offset = offset;
            this.form.page = page;

            let loader = this.$loading.show();

            axios.post(api.path('banner.list'), this.form)
                .then(res => res.data)
                .then(res => {
                    this.rows = res.data.data;
                    this.pages = res.data.pages;
                    loader.hide();
            });
        },

        onListChange(page) {
            this.page = page;
            this.search(10, page);
        },
    }


}
</script>
